<template>
  <div class="c-resources-card">
    <div
      v-if="result.image"
      class="c-resources-card__img"
      v-bind:style="{backgroundImage: 'url(' + result.image.url +')'}"
    ></div>
    <div class="c-resources-card__content">
      <span class="c-resources-card__ribbon" v-if="result.type">{{result.type}}</span>
      <h3 class="c-resources-card__title" v-bind:href="result.url">{{result.title}}</h3>
      <p class="c-resources-card__summary" v-if="result.body">{{result.body}}</p>
      <div class="c-resources-card__actions">
        <button
          class="c-button"
          :class="getButtonState(result.id)"
          type="submit"
          v-if="result.requestedItem && showForm"
          v-on:click="toggleItem"
        >{{ this.activeItem ? getActiveButtonText() : getDefaultButtonText()}}</button>
        <a
          class="c-button"
          :class="result.button.asLink ? 'c-button--neutral' : 'c-button--secondary' "
          target="_blank"
          :href="result.button.url"
          v-if="result.button"
        >{{ result.button.text}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "resources-results-card",
  props: {
    result: {
      type: Object,
      required: true,
    },
    requestedButtonsText: {
      type: String,
      required: true,
    },
    requestedButtonsActiveText: {
      type: String,
      required: true,
    },
    requestedItems: {
      required: false,
      type: Array,
    },
    showForm: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      activeItem: false,
    };
  },
  methods: {
    toggleItem() {
      this.activeItem = !this.activeItem;
      if (this.activeItem) {
        this.$emit("addItem", this.result);
      } else {
        this.$emit("removeItem", this.result.id);
      }
    },
    getButtonState(id) {
      this.activeItem = this.requestedItems.some((item) => item.id === id);
      if (this.activeItem) {
        return "c-button--destructive";
      } else {
        return "c-button--brand";
      }
    },
    getDefaultButtonText() {
      if (
        this.result.requestedItem.requestedButtonText === undefined ||
        this.result.requestedItem.requestedButtonText === "" ||
        this.result.requestedItem.requestedButtonText === null ||
        this.result.requestedItem.requestedButtonText === false
      ) {
        if (
          this.requestedButtonsText === undefined ||
          this.requestedButtonsText === "" ||
          this.result.requestedItem.requestedButtonText === null ||
          this.requestedButtonsText === false
        ) {
          return "Request item";
        }
        return this.requestedButtonsText;
      }
      return this.result.requestedItem.requestedButtonText;
    },
    getActiveButtonText() {
      if (
        this.result.requestedItem.requestedButtonActiveText === undefined ||
        this.result.requestedItem.requestedButtonActiveText === "" ||
        this.result.requestedItem.requestedButtonActiveText === null ||
        this.result.requestedItem.requestedButtonActiveText === false
      ) {
        if (
          this.requestedButtonsActiveText === undefined ||
          this.requestedButtonsActiveText === "" ||
          this.requestedButtonsActiveText === null ||
          this.requestedButtonsActiveText === false
        ) {
          return "Remove item";
        }
        return this.requestedButtonsActiveText;
      }
      return this.result.requestedItem.requestedButtonActiveText;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/components/geneco/resources/card/Card.vue